import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BellAlertIcon } from '@heroicons/react/24/outline';
import { alerteService } from '../../api/services';
import { Alerte } from '../../types';
import { LoadingSpinner } from '../../components/common/LoadingSpinner';

const SEVERITE_STYLE: Record<Alerte['severite'], string> = {
  CRITIQUE: 'border-l-red-500 bg-red-50',
  ATTENTION: 'border-l-amber-500 bg-amber-50',
  INFO: 'border-l-blue-500 bg-blue-50',
};

const SEVERITE_LABEL: Record<Alerte['severite'], string> = {
  CRITIQUE: 'Critique',
  ATTENTION: 'Attention',
  INFO: 'Info',
};

export function Alertes() {
  const navigate = useNavigate();
  const [alertes, setAlertes] = useState<Alerte[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    alerteService.getAll().then(setAlertes).finally(() => setLoading(false));
  }, []);

  if (loading) return <LoadingSpinner />;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="page-title">Centre d'alertes</h1>
        <p className="page-subtitle">Les signaux actionnables qui demandent votre attention</p>
      </div>

      {alertes.length === 0 ? (
        <div className="card text-center py-12 text-gray-500">
          <BellAlertIcon className="h-10 w-10 mx-auto text-gray-300 mb-2" />
          Aucune alerte. Tout est sous contrôle.
        </div>
      ) : (
        <div className="space-y-3">
          {alertes.map((a, i) => (
            <button
              key={i}
              onClick={() => navigate(a.lien)}
              className={`w-full text-left border-l-4 rounded-md p-4 flex items-center justify-between hover:shadow-sm transition ${SEVERITE_STYLE[a.severite]}`}
            >
              <div>
                <p className="font-medium text-gray-800">{a.message}</p>
                <p className="text-xs text-gray-500 mt-0.5">{SEVERITE_LABEL[a.severite]}</p>
              </div>
              <span className="text-2xl font-bold text-gray-700">{a.nombre}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default Alertes;
